<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <!-- Univ Course selection Model -->
          <b-modal class="xxl" :title="univCourseSelectionModalTitle" v-model="showUnivCourseSelectionModal" no-close-on-backdrop no-close-on-esc @hide="closeUnivCourseSelectionModal">
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <b-button variant="primary" @click="addCourseToUniv(univCourseObj)" class="pull-right mr-2 mb-1 btn-primary">Add Program/Course</b-button>
                  <h5>{{ univCourseObj.org_name }}</h5>
                </div>

                <div class="col-md-12 mb-3" v-if="univCourseObjectList">
                  <label for="univCourSelectCourseNameLabel">{{ cvUniversityCourseNameLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                  <select id="univCourSelectCourseNameLabel" v-model="univCourseObj.cour_id" @change="onCourseSelect" class="form-control">
                    <option disabled :value="null">Select Course/Program</option>
                    <option :value="course.cour_id" v-for="(course) in univCourseObjectList" :key="course.cour_id">{{course.cour_name}}</option>
                  </select>
                  <label><small class="primary-color">Courses, once recommended for a student, will no longer appear in the list above for that student.</small></label>
                </div>

                <div class="col-md-12 mb-3" v-if="org_application_deadlineList[univCourseObj.org_id] && Object.keys(org_application_deadlineList[univCourseObj.org_id]).length > 0">
                  <label for="univApplicationDeadlineLabel">{{ univApplicationDeadlineLabel }} {{ Object.keys(org_application_deadlineList[univCourseObj.org_id]).length }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                  <select id="univApplicationDeadlineLabel" v-model="org_application_deadline_forstudent" class="form-control">
                    <option disabled :value="null">Select Application Deadline For Student</option>
                    <option :value="deadline" v-for="(i, deadline) of org_application_deadlineList[univCourseObj.org_id]" :key="deadline">{{deadline}}</option>
                  </select>
                </div>

                <div v-if="univCourseObjectList" class="col-md-12 mb-3">
                  <label v-if="vmOrganisationFormData.org_application_deadline_internal">Current Application Deadline (Internal): <b><span v-html="vmOrganisationFormData.org_application_deadline_internal"></span></b></label><br>
                  <label>Set New {{cvOrgDeadlineInternalLabel}}</label>
                  <datetime
                    type="date"
                    v-model="vmOrganisationFormData.org_application_deadline_internal"
                    input-class="gide_datetime_input form-control"
                    class="datetime-theme-primary"
                    :format="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                    value-zone="local"
                    zone="local"
                    auto
                    :min-datetime="minStartDate"
                    @input="formatInternalDeadlineDate"
                  ></datetime>

                  <label><small class="primary-color">*Note: This deadline will be applicable for all students for this university.</small></label>
                  <label><small class="primary-color">*Note: The deadline should be a future date and time.</small></label>
                </div><br>

                <button
                  v-if="univCourseObjectList"
                  type="button"
                  class="btn btn-primary ml-1"
                  :disabled="!vmOrganisationFormData.org_application_deadline_internal || moment(vmOrganisationFormData.org_application_deadline_internal).isSameOrBefore(moment(minStartDate), 'day')"
                  @click="addUnivToAdmission()"
                >
                  Recommend
                </button>
              </div>
            </form>
            <template #modal-footer="">
              <b-button size="sm" class="pull-left" variant="secondary" @click="closeUnivCourseSelectionModal()">
                {{modalCancelBtnText}}
              </b-button>
            </template>
          </b-modal><!-- Univ Course selection Model -->

          <!-- University Course Add Modal -->
          <b-modal v-model="showModelUniversityCourseAdd" scrollable :title="cvAddModalHeader" size="xl">
            <UniversityCourseAdd :propOpenedInModal="true" :propUnivDetail="UnivObj"
              @emitCloseUniversityCourseAddModal="closeUniversityCourseAddModal" />
              <template #modal-footer="">
                <b-button size="sm" class="pull-left" variant="secondary" @click="closeUniversityCourseAddModal()">
                  {{modalCancelBtnText}}
                </b-button>
              </template>
          </b-modal><!-- University Course Add Modal -->

          <!-- Add Edit Internal And External Model -->
          <b-modal class="xxl" :title="univDeadlineTitle" v-model="showAddEditDeadlineModal" no-close-on-backdrop no-close-on-esc @hide="closeAddEditDeadlineModalnModal">
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label>{{cvOrgDeadlineLabel}}</label>
                  <textarea placeholder='' v-model="vmOrganisationFormData.org_application_deadline" type="text" class="form-control textarea"></textarea>
                </div><br>

                <div class="col-md-12 mb-3">
                  <label>{{cvOrgDeadlineInternalLabel}}</label>
                  <input
                    v-model="vmOrganisationFormData.org_application_deadline_internal"
                    type="date"
                    class="form-control"
                    required
                  />
                </div><br>

                <button type="button" class="btn btn-primary ml-1" @click="organisationEditDeadline()">Add Deadline</button>
              </div>
            </form>
            <template #modal-footer="">
              <b-button size="sm" class="pull-left" variant="secondary" @click="closeAddEditDeadlineModalnModal()">
                {{modalCancelBtnText}}
              </b-button>
            </template>
          </b-modal><!-- Add Edit Internal And External Mode -->

          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4 v-if="propSpcmObj" @click="gotoUserProfile(propSpcmObj)">
              <i class="fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{ propSpcmObj.user_name }}'s {{ cvCardTitle }} Shortlist
            </h4>
            <h4 v-else>
              <i class="fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              Recommend Universities
            </h4>
            <small small v-if="propSpcmObj">{{ propSpcmObj.user_id }}</small>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" v-if="propSpcmObj" variant="primary" @click="openUnivListModal()">{{cvbtnAddNewReco}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" v-else variant="primary" @click="goToOrgAdd()">{{cvbtnAddNewUniv}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
          <b-row class="mb-2 col-12">
            <b-col class="col-12">
              <!-- Frontend Search -->
              <!-- <b-form-input
                v-model="filter"
                type="search"
                :placeholder="cvSearchText"></b-form-input> --><!-- Frontend Search -->

              <!--Backend Search  -->
              <input class="form-control"
                v-model="whereFilter.search_param"
                type="search"
                @input="searchFromBackend"
                :placeholder="cvSearchText" /><!--Backend Search  -->
            </b-col>
          </b-row>
          <b-row class="mb-2 col-12">
            <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.country" class="form-control" @change="setFilters" title="Choose Country">
                  <option :value="null" disabled>Choose Country</option>
                  <option :value=null>All</option>
                  <option v-for="(country, index) of univFiltersList['org_country']" :key="(index+1)" :value="country.org_country">
                    {{country.org_country}}
                  </option>
                </select>
            </b-col>
            <b-col class="mb-2 col-12 col-sm-4">
              <select v-model="whereFilter.is_partner" class="form-control" @change="setFilters" title="Org Partnership Type">
                <option :value="null" disabled>Choose University Partner type</option>
                <option :value=null>All</option>
                <option v-for="(orgpartnerType, index) of univFiltersList['is_partner']" :key="(index+1)" :value="orgpartnerType.is_partner">
                  {{orgpartnerType.is_partner}}
                </option>
              </select>
            </b-col>
            <b-col class="mb-2 col-12 col-sm-4">
              <multiselect
                v-model="whereFilter.cour_name"
                :options="courseNameList"
                :searchable="true"
                :internal-search="false"
                label="cour_name"
                track-by="cour_name"
                placeholder="Choose Course Name"
                @search-change="onSearchCourse"
                @input="setFilters"
              />
            </b-col>
          </b-row>
        </div>
        <div class="iq-card row p-3">
          <b-col md="12" v-if="univObjList && univObjList.length > 0">
            <b-table
              hover
              responsive
              :items="univObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="perPage">
              <template v-slot:cell(org_name)="data">
                <b><span class="pointer" @click="openUnivDetails(data.item)">{{ data.item.org_name }}</span></b><br>
                <small>
                  {{ data.item.org_city ? `${data.item.org_city}` : "" }}{{ data.item.org_state ? `, ${data.item.org_state}` : "" }}{{ data.item.org_country ? `, ${data.item.org_country}` : "" }}<br>
                  Id:&nbsp;{{ data.item.org_id }}
                </small><br>
                <div>
                  <b-badge v-if="data.item.univ_type == 'Private'" style="background-color:#990099; color: #fff;" size="sm" variant="mr-0 mb-0">{{ data.item.univ_type }}</b-badge>
                  <b-badge v-else-if="data.item.univ_type == 'Public'" style="background-color:#008B8B; color: #fff;" size="sm" variant="mr-0 mb-0">{{ data.item.univ_type }}</b-badge>
                  <b-badge v-else-if="data.item.univ_type == 'LAC'" style="background-color:#FF8C00; color: #fff;" size="sm" variant="mr-0 mb-0">{{ data.item.univ_type }}</b-badge>
                  <b-badge v-else style="background-color: #5574A6; color: #fff;" size="sm" variant="mr-0 mb-0">{{ data.item.univ_type }}</b-badge>
                </div><br>
                <b-button v-if="!propSpcmObj" class="btn btn actionIcon mr-1 btn-secondary btn-sm" @click="openUnivCourseSelectionModal(data.item)" size="sm" title="Recommend University"><i class="fa-solid fa-heart-circle-plus m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button>
                <b-button class="btn btn actionIcon font-size-18 mr-1 btn-secondary btn-sm" @click="goToOrgEdit(data.item)" size="sm" title="Edit University"><i class="fa-solid fa-pencil m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button>
                <b-button class="btn btn actionIcon font-size-18 mr-1 btn-secondary btn-sm" @click="goToOrganisationCourses(data.item)" size="sm" title="Courses"><i class="fa fa-book m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button>
                <b-button class="btn btn actionIcon font-size-18 mr-1 btn-secondary btn-sm" @click="gotoActivityURL(data.item.org_url)" size="sm" title="Activity"><i class="fa-brands fa-chrome m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button>
                <b-button v-if="propSpcmObj" class="btn btn actionIcon mr-1 btn-secondary btn-sm" @click="openUnivDeadlineModal(data.item)" size="sm" title="Change University Deadlines For Student"><i class="fa-solid fa-calendar pointer ml-3 m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button>
              </template>
              <template v-slot:cell(org_drs)="data">
                {{ data.item.org_drs.toUpperCase() }}
              </template>
              <template v-slot:cell(org_application_deadline)="data">
                <span v-html="getApplicationDeadlines(data.item)"></span><br>
                <small>
                  <span>Internal Deadline:</span>&nbsp;
                  <span v-if="data.item.org_application_deadline_internal" class="primary-color pointer" title="Edit Deadline" @click="openInternalAndExternalDeadline(data.item)">{{ data.item.org_application_deadline_internal|dateFormatDDMMYYYY }}</span>
                  <span class="primary-color pointer" title="Edit Deadline" @click="openInternalAndExternalDeadline(data.item)"><b-button class="btn btn actionIcon font-size-18 mr-1 btn-secondary btn-sm" @click="openInternalAndExternalDeadline(data)" size="sm" title="Edit Deadline"><i class="fa-solid fa-calendar-days m-0 font-size-20 primary-color" aria-hidden="true"></i></b-button></span>
                </small>
              </template>
              <template v-slot:cell(scholarship_id)="data">
                {{data.item.scholarship_id ? data.item.scholarship_id.split(",").length : 0}}
              </template>
              <template v-slot:cell(org_acceptance_rate)="data">
                {{ getAcceptanceRate(data.item.org_acceptance_rate) }}
              </template>
              <template v-slot:cell(org_avg_tuition_min)="data">
                {{ data.item.org_avg_tuition_min ? `${data.item.org_avg_tuition_min} - ${data.item.org_avg_tuition_max}` : "N/A" }}
              </template>
              <template v-slot:cell(org_sat_min)="data">
                {{ data.item.org_sat_min ? `${data.item.org_sat_min} - ${data.item.org_sat_max}` : "TEST BLIND" }}
              </template>
              <template v-slot:cell(org_act_min)="data">
                {{ data.item.org_act_min ? `${data.item.org_act_min} - ${data.item.org_act_max}` : "TEST BLIND"}}
              </template>
              <template v-slot:cell(cour_name)="data">
                <span>{{ data.item.cour_degree_name }}</span><br />
                <span>{{ data.item.cour_name }}</span><br />
                <div v-if="data.item.cour_url">
                  <b-button class="btn btn actionIcon font-size-18 mr-1 btn-secondary btn-sm" @click="goToUnivCoursePage(data.item.cour_url)" size="sm" title="Course Page"><i class="fa-brands fa-chrome font-size-20 primary-color"></i></b-button>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col md="12" v-else>
            <span v-if="showDefaultForRecommedUnivList">
              We did not find any shortlisted universities. <span class="pointer primary-color" @click="openUnivListModal()">Click here</span> to recommend universities.
            </span>
            <span v-else>
              We did not find any matching universities.
            </span>
          </b-col>
          <b-col sm="7" md="8" class="my-1">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!--University Add -->
    <b-modal
      v-model="showModelOrganisationAdd"
      scrollable
      :title="cvAddUniAddHeader"
      size="xxl"
    >
      <UniversityAdd :propOpenedInModal="true" @emitCloseOrganisationAddModal="closeOrganisationAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeOrganisationAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!--University Add -->

    <!--University Edit -->
    <b-modal
      v-model="showModelOrganisationEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <UniversityEdit :propOpenedInModal="true" :propOrganisationObj="organisationEditObj" @emitCloseOrganisationEditModal="closeOrganisationEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeOrganisationEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!--University Edit -->

    <!--University Course List-->
    <b-modal
      v-model="showModelUniversityCourseList"
      scrollable
      :title="cvUniversityCourseHeader"
      size="xxl"
    >
      <UniversityCourseList :propOpenedInModal="true" :propUnivDetail = "organisationCourseObj" @emitUniversityCourseListModal="closeUniversityCourseListModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeUniversityCourseModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!--University Course List-->

    <!--Applicable Deadline for this Student-->
    <b-modal
      v-model="showDeadlineModel"
      scrollable
      :title="cvDeadlineHeader"
      size="xxl"
      hide-footer
    >
      <div class="col-md-12 mb-3" v-if="this.org_application_deadlineList[univDeadlineObj.org_id] && Object.keys(this.org_application_deadlineList[univDeadlineObj.org_id]).length > 0">
        <label for="univApplicationDeadlineLabel">{{ univApplicationDeadlineLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
        <select id="univApplicationDeadlineLabel" v-model="univDeadlineObj.org_application_deadline_forstudent" class="form-control">
          <option disabled :value="null">Select Application Deadline For Student</option>
          <option :value="deadline" v-for="(i, deadline) of this.org_application_deadlineList[univDeadlineObj.org_id]" :key="deadline">{{i}}</option>
        </select>
      </div>
      <div class="mt-4">
        <b-btn type="button" variant="primary" class="pull-left" @click="editAdmission(univDeadlineObj)">
          {{cvAddAdmissionBtn}}
        </b-btn>
      </div>
  </b-modal><!--Applicable Deadline for this Student-->

  <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>
<script>
import "vue-datetime/dist/vue-datetime.css"
import { Organisations } from "../../../FackApi/api/organisation.js"
import { UniversityCourses } from "../../../FackApi/api/universityCourse.js"
import moment from "moment"
import { socialvue } from "../../../config/pluginInit.js"
import { Admissions } from "../../../FackApi/api/admission.js"
import ColorCodes from "../../../Utils/colorcodes"
import UniversityCourseAdd from "../ListPages/University Courses/UniversityCourseAdd.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import UniversityAdd from "../Organisation/UniversityAdd.vue"
import UniversityEdit from "../Organisation/UniversityEdit.vue"
import UniversityCourseList from "../ListPages/University Courses/UniversityCourseList.vue"
import Multiselect from "vue-multiselect"
import { Datetime } from "vue-datetime"

export default {
  name: "SpcmUnivList",
  props: {
    propSpcmObj: {
      type: Object,
      default: null
    },
    propUserUnivReco: {
      type: Array,
      default: null
    }
  },
  components: {
    UniversityCourseAdd,
    UniversityAdd,
    UniversityEdit,
    UniversityCourseList,
    Multiselect,
    Datetime
  },
  data () {
    return {
      cvCardTitle: "University",
      cvSearchText: "Type to Search",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "University",
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Name", key: "org_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "DRS", key: "org_drs", class: "text-left align-text-top", sortable: true },
        { label: "Application Deadline", key: "org_application_deadline", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Rank", key: "org_rank", class: "text-left align-text-top", sortable: true },
        { label: "Avail. Scholarships", key: "scholarship_id", class: "text-left align-text-top", sortable: true },
        { label: "Partnership", key: "is_partner", class: "text-left align-text-top", sortable: true },
        { label: "Acceptance Rate", key: "org_acceptance_rate", class: "text-left align-text-top", sortable: true },
        { label: "Tuition Fees", key: "org_avg_tuition_min", class: "text-left align-text-top w-100px", sortable: true },
        { label: "SAT Score", key: "org_sat_min", class: "text-left align-text-top w-100px", sortable: true },
        { label: "ACT Score", key: "org_act_min", class: "text-left align-text-top w-100px", sortable: true }
      ],
      univObjList: [],
      univFiltersList: [],
      courseNameList: [],
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentBatchNo: 1,
      perPage: 200,
      cvbtnAddNewReco: "Add to Shortlist",
      cvbtnAddNewUniv: "Add",
      colorCodeList: ColorCodes.colorCodeList,
      whereFilter: {
        "country": "null",
        "is_partner": "null",
        "cour_name": null
      },
      univCourseSelectionModalTitle: "Select Course/Progam",
      modalCancelBtnText: "Cancel",
      cvUniversityNameLabel: "University Name",
      cvUniversityCourseNameLabel: "Course Name",
      showUnivCourseSelectionModal: false,
      showAddEditDeadlineModal: false,
      univCourseObj: {
        cour_id: null
      },
      univCourseObjectList: null,
      showModelUniversityCourseAdd: false,
      cvAddModalHeader: "Add Program/Course",
      showDefaultForRecommedUnivList: true,
      showLoadMoreBtn: true,
      showModelOrganisationAdd: false,
      showModelUniversityCourseList: false,
      showModelOrganisationEdit: false,
      cvAddUniAddHeader: "Add University",
      cvUniversityCourseHeader: "University Course List",
      cvbtnModalCancel: "close",
      cvEditModalHeader: "Edit Organisation",
      organisationEditObj: null,
      organisationCourseObj: null,
      vmOrganisationFormData: Object.assign({}, this.initFormData()),
      cvOrgDeadlineInternalLabel: "Application Deadline (Internal)",
      cvOrgDeadlineLabel: "University Application Deadlines",
      univDeadlineTitle: "Application Deadlines",
      organisationDetailObj: null,
      UnivObj: null,
      univApplicationDeadlineLabel: "Choose the Applicable Deadline for this Student",
      org_application_deadlineList: {},
      org_application_deadline_forstudent: null,
      showDeadlineModel: false,
      cvAddAdmissionBtn: "Save",
      cvDeadlineHeader: "Set New University Deadline for Student",
      univDeadlineObj: {},
      defaultOrgInternalDeadline: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    minStartDate () {
      return moment().startOf("day").toISOString()
    }
  },
  async mounted () {
    socialvue.index()
    this.orgCourseFilterGet()
    await this.univFilterList("is_partner")
    await this.univFilterList("org_country")

    if (this.propSpcmObj && this.propSpcmObj.user_id) {
      // University reco list expanded
      this.columns.push({ label: "Course Details", key: "cour_name", class: "text-left align-text-top w-100px", sortable: true })
      this.showDefaultForRecommedUnivList = true
      this.getStudentAdmUnivDetailsList()
    }
    else {
      this.showDefaultForRecommedUnivList = false
      this.organisationList()
    }
  },
  methods: {
    /**
     * Format selected ISO datetime into clean YYYY-MM-DD date string
     */
    formatInternalDeadlineDate (val) {
      if (val) {
        this.vmOrganisationFormData.org_application_deadline_internal = moment(val).format("YYYY-MM-DD")
      }
    },
    /**
     * onSearchCourse
     */
    onSearchCourse (search) {
      if (!search || search.length < 2) {
        // reset course list when search is cleared
        if (search === "") {
          this.orgCourseFilterGet("", false)
        }
      }
      else {
        this.orgCourseFilterGet(search, true)
      }
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        "org_application_deadline": ""
      }
    },
    /**
     * organisationList
     */
    async organisationList (loadViaLoadMore = false) {
      try {
        let whereFilter = {}
        for (const property in this.whereFilter) {
          if (this.whereFilter[property] && this.whereFilter[property] != "null" && this.whereFilter[property] != " ") {
            whereFilter[property] = this.whereFilter[property]
          }
        }

        let filter = { type: ["UNIV"], user_role: this.userData.user_role, ...whereFilter, limit: this.perPage }
        if (this.whereFilter.search_param) {
          filter = { ...filter,
            where: {
              "OR":
                [
                  {
                    org_name: this.whereFilter.search_param
                  },
                  {
                    org_desc: this.whereFilter.search_param
                  },
                  {
                    org_city: this.whereFilter.search_param
                  },
                  {
                    org_country: this.whereFilter.search_param
                  },
                  {
                    org_founding_year: this.whereFilter.search_param
                  },
                  {
                    org_avg_tuition_min: this.whereFilter.search_param
                  },
                  {
                    org_avg_tuition_max: this.whereFilter.search_param
                  },
                  {
                    org_scholarship_min: this.whereFilter.search_param
                  },
                  {
                    org_scholarship_max: this.whereFilter.search_param
                  },
                  {
                    org_application_deadline: this.whereFilter.search_param
                  }
                ]
            }
          }
        }

        let univListResp = await Organisations.organisationList(this, filter, this.currentBatchNo)
        if (univListResp.resp_status) {
          if (loadViaLoadMore) {
            this.univObjList = [...this.univObjList, ...Object.values(univListResp.resp_data.data)]
          }
          else {
            this.univObjList = Object.values(univListResp.resp_data.data)
          }

          this.totalRows = this.univObjList.length
          this.showLoadMoreBtn = true
        }
        else {
          this.currentBatchNo--
          this.showLoadMoreBtn = false
          this.univObjList = []
          ApiResponse.responseMessageDisplay(this, univListResp)
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationList() and Exception:", err.message)
      }
    },
    /**
     * getStudentAdmUnivDetailsList
     */
    async getStudentAdmUnivDetailsList () {
      try {
        const postDataObj = {}
        if (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") {
          postDataObj.gide_user_id = this.propSpcmObj.user_id
        }
        else {
          postDataObj.gide_user_id = this.userData.user_id
        }
        if (this.whereFilter.search_param) {
          postDataObj.search_param = this.whereFilter.search_param
        }
        postDataObj.currentBatchNo = this.currentBatchNo
        postDataObj.dataPerPage = this.perPage

        // Passing the filters (partnership_type, country, and course_name) for shortlisted universities too
        let whereFilter = {}
        for (const property in this.whereFilter) {
          if (this.whereFilter[property] && this.whereFilter[property] != "null" && this.whereFilter[property] != " ") {
            whereFilter[property] = this.whereFilter[property]
          }
        }
        postDataObj.filter = JSON.stringify(whereFilter)

        const studentUnivDetailsListResp = await Admissions.admissionStudentUniversityDetailsList(this, postDataObj)
        if (studentUnivDetailsListResp.resp_status) {
          this.univObjList = studentUnivDetailsListResp.resp_data.data
          this.totalRows = studentUnivDetailsListResp.resp_data.count
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo--
          ApiResponse.responseMessageDisplay(this, studentUnivDetailsListResp)
        }
      }
      catch (err) {
        console.error("Exception in getStudentAdmUnivDetailsList and err: ", err.message)
      }
    },
    /**
     * goToUnivEdit
     */
    goToUnivEdit (univObj) {
      window.open(`${process.env.VUE_APP_SERVER_URL}/organisation_edit/UNIV/${univObj.org_id}`)
    },
    /**
     * openUnivListModal
     */
    openUnivListModal () {
      this.$emit("emitOpenUnivListModal")
    },
    /**
     * Redirect to User Profile
    */
    gotoUserProfile (user) {
      try {
        window.open(`/user/${user.user_id}`)
      }
      catch (err) {
        console.error("Exception occurred at UserList() and Exception:", err.message)
      }
    },
    /**
     * openUnivCourseSelectionModal
     */
    async openUnivCourseSelectionModal (univObj) {
      // Store default org deadline to use as fallback
      this.defaultOrgInternalDeadline = univObj.org_application_deadline_internal || null

      // Get the courses of the university
      this.univCourseObj = univObj
      this.univCourseObj.cour_id = null

      this.vmOrganisationFormData.org_application_deadline_internal = null

      const universityCourseList = await UniversityCourses.organisationCourseList(this, { org_id: univObj.org_id })

      if (universityCourseList.resp_status) {
        // Removing the already selected courses from the dropdown
        const courseObjList = universityCourseList.resp_data.data.filter((e) => {
          return !this.propUserUnivReco.find(admObj => {
            return admObj.cour_id && admObj.cour_id == e.cour_id
          })
        })

        this.univCourseObjectList = courseObjList
      }
      else {
        this.univCourseObjectList = null
      }

      this.showUnivCourseSelectionModal = true
      this.organisationView(univObj)

      // Ensure initial view has org deadline set if present
      if (!this.vmOrganisationFormData.org_application_deadline_internal && this.defaultOrgInternalDeadline) {
        this.vmOrganisationFormData.org_application_deadline_internal = this.defaultOrgInternalDeadline
      }
    },
    /**
     *  onCourseSelect
     */
    onCourseSelect () {
      const selectedCourse = this.univCourseObjectList.find(c => c.cour_id === this.univCourseObj.cour_id)
      if (selectedCourse && selectedCourse.org_application_deadline_internal) {
        // 1. Use course-level internal deadline if available
        this.vmOrganisationFormData.org_application_deadline_internal = selectedCourse.org_application_deadline_internal
      }
      else {
        // 2. Revert/Fallback to university-level internal deadline
        this.vmOrganisationFormData.org_application_deadline_internal = this.defaultOrgInternalDeadline
      }
    },
    /**
     * closeUnivCourseSelectionModal
     */
    closeUnivCourseSelectionModal () {
      this.showUnivCourseSelectionModal = false
    },
    /**
     * addUnivToAdmission
     */
    async addUnivToAdmission () {
      if (!this.univCourseObj.cour_id) {
        this.toastTitle = "Course/Program"
        this.toastMsg = "Please select a course"
        this.toastVariant = "danger"
        this.showToast = true
        return
      }

      this.organisationEdit() // we need to update the deadline for this student in the organisation table before adding the admission record

      const courseObj = this.univCourseObjectList.find(e => e.cour_id == this.univCourseObj.cour_id)
      const admData = { ...this.univCourseObj }
      admData.cour_degree_name = courseObj.cour_degree_name
      admData.cour_name = courseObj.cour_name
      admData.org_application_deadline_forstudent = this.org_application_deadline_forstudent
      admData.org_application_deadline_internal = this.vmOrganisationFormData.org_application_deadline_internal
      this.$emit("emitAddUnivReco", admData)
      this.showUnivCourseSelectionModal = false
      this.showAddEditDeadlineModal = false
    },
    /**
     * goToOrgAdd
     */
    goToOrgAdd () {
      this.showModelOrganisationAdd = true
    },
    /**
     * goToOrgEdit
     */
    goToOrgEdit (item) {
      this.organisationEditObj = item
      this.showModelOrganisationEdit = true
    },
    /**
     * goToOrganisationCourses
     */
    goToOrganisationCourses (item) {
      this.organisationCourseObj = item
      this.showModelUniversityCourseList = true
    },
    /**
     * getAcceptanceRate
     */
    getAcceptanceRate (rate) {
      let newrate = rate.includes("%") ? rate : `${rate}%`
      if (newrate == "0%") {
        newrate = "N/A"
      }

      return newrate
    },
    /**
     * getColorCode
     */
    getColorCode (index) {
      switch (index) {
        case "d":
          return ColorCodes.getBgColor(24)
        case "r":
          return ColorCodes.getBgColor(25)
        case "s":
          return ColorCodes.getBgColor(23)
        default:
          return ColorCodes.getBgColor(index)
      }
    },
    /*
    * univFilterList
    */
    async univFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let univFilterListResp = await Organisations.organisationFilterList(this, "UNIV", filterName)
        if (univFilterListResp) {
          this.univFiltersList[filterName] = univFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at univ_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * setFilters
    */
    async setFilters () {
      this.currentBatchNo = 1
      if (this.propSpcmObj && this.propSpcmObj.user_id) {
        // University reco list expanded
        this.showDefaultForRecommedUnivList = true
        await this.getStudentAdmUnivDetailsList()
      }
      else {
        this.showDefaultForRecommedUnivList = false
        await this.organisationList()
      }
    },
    /**
     * addCourseToUniv
     */
    addCourseToUniv (item) {
      this.UnivObj = item
      this.showModelUniversityCourseAdd = true
    },
    /*
    * orgCourseFilterGet
    */
    async orgCourseFilterGet (searchParam = null, isSearch = false) {
      try {
        let payload = {
          wherefilter: {
            search_param: ""
          },
          limit: 25
        }

        if (isSearch && searchParam && searchParam.length > 0) {
          payload.wherefilter.search_param = searchParam
          payload.limit = null
        }

        let orgFilterListResp = await UniversityCourses.organisationCourseFilterGet(this, payload)
        if (orgFilterListResp.resp_status) {
          this.courseNameList = orgFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at orgCourseFilterGet() and Exception:", err.message)
      }
    },
    /**
     * closeUniversityCourseAddModal
     */
    closeUniversityCourseAddModal (organisationCourseAddData) {
      try {
        if (this.univCourseObjectList) {
          this.univCourseObjectList.unshift(organisationCourseAddData)
        }
        else {
          this.univCourseObjectList = [organisationCourseAddData]
        }

        this.showModelUniversityCourseAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeorganisationCourseAddModal() and Exception:", err.message)
      }
      this.showModelUniversityCourseAdd = false
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo++

      if (this.propSpcmObj && this.propSpcmObj.user_id) {
        // University reco list expanded
        this.showDefaultForRecommedUnivList = true
        this.getStudentAdmUnivDetailsList(true)
      }
      else {
        this.showDefaultForRecommedUnivList = false
        this.organisationList(true)
      }
    },
    /**
      * searchFromBackend
    */
    searchFromBackend () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }

      this.currentBatchNo = 1
      if (this.propSpcmObj && this.propSpcmObj.user_id) {
        // University reco list expanded
        this.showDefaultForRecommedUnivList = true
        this.getStudentAdmUnivDetailsList()
      }
      else {
        this.showDefaultForRecommedUnivList = false
        this.organisationList()
      }
    },
    /**
     * openUnivDetails
     */
    openUnivDetails (orgObj) {
      window.open(`/organisations/UNIV/${orgObj.org_id}`)
    },
    /**
     * closeOrganisationAddModal
     */
    closeOrganisationAddModal (organisationAddData) {
      try {
        if (organisationAddData) {
          if (this.organisationObjList && this.organisationObjList.length >= 1) {
            let organisationObjLength = this.organisationObjList.length
            let lastId = this.organisationObjList[organisationObjLength - 1]["id"]
            organisationAddData.id = lastId + 1
          }
          else {
            this.organisationObjList = []
            organisationAddData.id = 11111
          }

          organisationAddData.created_on = moment()
          this.organisationObjList.unshift(organisationAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelOrganisationAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeorganisationAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeOrganisationEditModal
     */
    closeOrganisationEditModal () {
      this.organisationList()
      this.showModelOrganisationEdit = false
    },
    /**
     * closeOrganisationEditModal
     */
    closeUniversityCourseListModal () {
      this.showModelUniversityCourseList = false
    },
    /**
     * goToUnivCoursePage
     */
    goToUnivCoursePage (courUrl) {
      window.open(courUrl, "_blank")
    },
    /*
     * goto Activity URL
     */
    gotoActivityURL (url) {
      if (url) {
        window.open(url, "_blank")
      }
    },
    /**
     * organisationEditDeadline
     */
    organisationEditDeadline () {
      this.organisationEdit()
      this.showAddEditDeadlineModal = false
    },
    /**
     * organisationEdit
     */
    async organisationEdit () {
      try {
        this.cvLoadingStatus = true

        let payload = {
          cour_id: this.univCourseObj.cour_id,
          org_id: this.vmOrganisationFormData.org_id,
          type: "UNIV",
          org_application_deadline_internal: this.vmOrganisationFormData.org_application_deadline_internal
        }

        if (this.vmOrganisationFormData.org_application_deadline) {
          payload.org_application_deadline = this.vmOrganisationFormData.org_application_deadline
        }

        let response = await Organisations.organisationEdit(this, payload)
        if (response && response.resp_status) {
          this.vmOrganisationFormData = Object.assign({}, this.initFormData())
          this.organisationList()
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * openInternalAndExternalDeadline
    */
    async openInternalAndExternalDeadline (item) {
      this.vmOrganisationFormData = { ...item }
      this.organisationView(item)
      this.organisationDetailObj = item
      this.showAddEditDeadlineModal = true
    },
    /**
     * closeAddEditDeadlineModalnModal
    */
    closeAddEditDeadlineModalnModal () {
      this.showAddEditDeadlineModal = false
    },
    /**
     * organisationView
    */
    async organisationView (univObj) {
      try {
        let organisationId = univObj.org_id
        let organisationViewResp = await Organisations.organisationView(this, organisationId, null, this.userData.user_role)
        if (organisationViewResp && organisationViewResp.resp_status) {
          this.vmOrganisationFormData = organisationViewResp.resp_data.data

          this.vmOrganisationFormData.org_application_deadline = await this.getApplicationDeadlines(this.vmOrganisationFormData, "NOTAGS")
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationView() and Exception:", err.message)
      }
    },
    /**
     * getApplicationDeadlines
     * If the Data Application Deadline data is in JSON string then parse and format XXX
     * else just format
     * If the it is found that a particular deadline is tagged to a student then highlight the option with color
     * Build an array of org specific deadlines for the ADMIN/COUNSELOR to choose and set for a stuent
     */
    getApplicationDeadlines (orgObj, responseWithHTMLTags = "TAGS") {
      try {
        let deadlines = orgObj.org_application_deadline
        let deadlinesObj = null
        let deadlineStr = ""

        let orgId = orgObj.org_id ? orgObj.org_id : orgObj.university_id
        orgObj.org_id = orgId
        if (!this.org_application_deadlineList[orgId]) {
          this.org_application_deadlineList[orgId] = {}
        }

        if (!deadlines) {
          if (responseWithHTMLTags == "TAGS") {
            deadlineStr += `<small>Deadlines Not Found</small><br>`
          }
          else {
            deadlineStr += `Deadlines Not Found\n`
          }
        }
        else if (deadlines.includes("{")) {
          deadlinesObj = JSON.parse(deadlines)
          for (const key in deadlinesObj) {
            let value = deadlinesObj[key]
            if (!value || value.includes("null")) {
              value = "--"
            }

            if (responseWithHTMLTags == "TAGS") {
              if (orgObj.org_application_deadline_forstudent && key.includes(orgObj.org_application_deadline_forstudent)) {
                deadlineStr += `<small class="information-color">${key}: <b>${value}</b></small><br>` // Required While Viewing
              }
              else {
                deadlineStr += `<small>${key}: ${value}</small><br>` // Required While Viewing
              }
            }
            else {
              deadlineStr += `${key}: ${value}\n`
            }

            this.org_application_deadlineList[orgObj.org_id][key] = key
          }
        }
        else {
          if (responseWithHTMLTags == "TAGS") {
            if (deadlines.includes("\n")) {
              deadlines = deadlines.replaceAll("\n", ",").replaceAll("\r", "")
            }
            let deadlinesArr = deadlines.split(",")

            let key = ""
            let value = ""

            for (let deadline of deadlinesArr) {
              deadline = deadline.trim()
              key = deadline.split(":")[0]
              value = deadline.split(":")[1]

              if (key.length <= 0) {
                continue
              }

              if (!value || value.includes("null")) {
                value = "--"
              }

              this.org_application_deadlineList[orgObj.org_id][key] = key

              if (orgObj.org_application_deadline_forstudent && key.includes(orgObj.org_application_deadline_forstudent)) {
                deadlineStr += `<small class="information-color">${key}: <b>${value}</b></small><br>` // Required While Viewing
              }
              else {
                deadlineStr += `<small>${key}: ${value}</small><br>` // Required While Viewing
              }
            }
          }
          else {
            deadlineStr += `${deadlines}\n`
          }
        }

        return deadlineStr
      }
      catch (e) {
        console.error("Ex. getApplicationDeadlines:", e)
      }
    },
    /**
     * editAdmission
     */
    async editAdmission (univObj) {
      try {
        const payload = {
          user_id: this.propSpcmObj.user_id,
          adm_id: univObj.adm_id,
          university_id: univObj.university_id,
          org_application_deadline_forstudent: univObj.org_application_deadline_forstudent
        }

        const admissionEditResp = await Admissions.admissionEdit(this, payload)
        if (admissionEditResp.resp_status) {
          this.refreshExpandedUnivRecoList++
          this.showDeadlineModel = false
        }
      }
      catch (err) {
        console.error("Exception in editAdmission and err: ", err.message)
      }
    },
    /**
     * openUnivDeadlineModal
     */
    openUnivDeadlineModal (univObj) {
      this.showDeadlineModel = true
      this.univDeadlineObj = univObj
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
